import axios from 'axios';
import { call, put, takeLatest, cps, all } from 'redux-saga/effects';
import { MembersActionCreators } from '../ActionCreators/MembersActionCreators';
import * as types from '../ActionTypes/MembersActionTypes';
import { members } from '../../BusinessLogic/Network/API/MembersApi';

export class MembersSaga {
    static *getMembers() {
        try {
            const _members = members.create();
            const { data: response } = yield call(axios, _members.getMembers());
            yield put(MembersActionCreators.getMembersSuccess(response.data));
        } catch (e) {
            console.log({ error: e });
        }
    }

    static *addMember({ meta: { userData, callback } }) {
        try {
            const _members = members.create();
            const { data: response } = yield call(axios, _members.addMember(userData));
            yield put(MembersActionCreators.addMemberSuccess(response.data));
            callback(response.data.id);
        } catch (error) {
            console.log({ error });
        }
    }

    static *updateMember({ meta: { memberId, creditsData } }) {
        try {
            const _members = members.create();
            const { data: response } = yield call(axios, _members.updateMember(memberId, creditsData));
            yield put(MembersActionCreators.updateMemberSuccess(response.data));
        } catch (error) {
            console.log({ error });
        }
    }

    static *deleteMember({ meta: { memberId, callback } }) {
        try {
            const _members = members.create();
            yield call(axios, _members.deleteMember(memberId));
            yield put(MembersActionCreators.deleteMemberSuccess(memberId));
            if (callback) callback();
        } catch (error) {
            console.log(error);
        }
    }

    static *addMembershipPlanToMember({ meta: { id, plans, cb } }) {
        try {
            const _members = members.create();
            const { data: response } = yield call(axios, _members.addPlansToMember(id, plans));
            yield put(MembersActionCreators.addMembershipPlanToMemberSuccess(response.data));
            if (cb) yield cps(cb);
        } catch (error) {
            yield put(MembersActionCreators.addMembershipPlansToMemberFailed(error));
        }
    }

    static *updateMembersMembershipPlan({ meta: { memberId, planMemberId, planData } }) {
        try {
            const _members = members.create();
            const { data: response } = yield call(
                axios,
                _members.updateMembersMembershipPlan(memberId, planMemberId, planData),
            );
            yield put(MembersActionCreators.updateMembersMembershipPlanSuccess(response.data));
        } catch (error) {
            yield put(MembersActionCreators.updateMembersMembershipPlanFailed(error));
        }
    }

    static *getMembersBirthdaysByDateRange({ meta: { start, end } }) {
        try {
            const _members = members.create();
            const { data: response } = yield call(axios, _members.getMembersBirthdaysByDateRange(start, end));
            yield put(MembersActionCreators.getMembersBirthdaysByDateRangeSuccess(response.data));
        } catch (error) {
            yield put(MembersActionCreators.getMembersBirthdaysByDateRangeFailed(error));
        }
    }

    static *inviteMembersByEmail({ meta: { membersInfo, callback } }) {
        try {
            const _members = members.create();

            if (Array.isArray(membersInfo)) {
                const response = yield all(
                    membersInfo.map(member => {
                        return call(axios, _members.inviteMemberByEmail(member));
                    }),
                );

                yield put(MembersActionCreators.inviteMemberByEmailSuccess(response));
                if (callback) yield cps(callback);
            }
        } catch (error) {
            yield put(MembersActionCreators.inviteMemberbyEmailFailed(error));
        }
    }

    static *getWaitingMembers() {
        try {
            const _members = members.create();

            const { data: response } = yield call(axios, _members.getWaitingMembers());
            yield put(MembersActionCreators.getWaitingMembersSuccess(response.data));
        } catch (error) {
            yield put(MembersActionCreators.getWaitingMembersFailed(error));
        }
    }

    static *getClassesForPlans() {
        try {
            const _members = members.create();

            const { data: response } = yield call(axios, _members.getClassesForPlans());
            yield put(MembersActionCreators.getClassesForPlansSuccess(response.data));
        } catch (error) {
            yield put(MembersActionCreators.getClassesForPlansFailed(error));
        }
    }

    static *assignClassesToPlan({ meta: { planId, seriesIds } }) {
        try {
            const _members = members.create();

            const { data: response } = yield call(axios, _members.assignClassesToPlan(planId, seriesIds));
            yield put(MembersActionCreators.assignClassesToPlanSuccess(response.data));
        } catch (error) {
            yield put(MembersActionCreators.assignClassesToPlanFailed());
        }
    }

    static *resendMemberInvitation({ meta: { memberId } }) {
        try {
            const _members = members.create();

            const { data: response } = yield call(axios, _members.resendInvitation(memberId));
            yield put(MembersActionCreators.resendInvitationSuccess(response.data));
        } catch (error) {
            yield put(MembersActionCreators.resendInvitationFailed());
        }
    }

    static *updateMemberStatus({ meta: { memberId, status, callback } }) {
        try {
            const _members = members.create();

            const { data: response } = yield call(axios, _members.updateStatus(memberId, status));
            yield put(MembersActionCreators.updateMemberStatusSuccess(response.data));
            if (callback) yield cps(callback);
        } catch (error) {
            yield put(MembersActionCreators.udpateMemberStatusFailed(error));
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_MEMBERS_REQUEST, MembersSaga.getMembers);
    yield takeLatest(types.ADD_MEMBER_REQUEST, MembersSaga.addMember);
    yield takeLatest(types.UPDATE_MEMBER_REQUEST, MembersSaga.updateMember);
    yield takeLatest(types.DELETE_MEBMER_REQUEST, MembersSaga.deleteMember);
    yield takeLatest(types.ADD_PLANS_TO_MEMBER_REQUEST, MembersSaga.addMembershipPlanToMember);
    yield takeLatest(types.UPDATE_MEMBERS_MEMBERSHIP_PLAN_REQUEST, MembersSaga.updateMembersMembershipPlan);
    yield takeLatest(types.GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_REQUEST, MembersSaga.getMembersBirthdaysByDateRange);
    yield takeLatest(types.INVITE_MEMBER_BY_EMAIL_REQUEST, MembersSaga.inviteMembersByEmail);
    yield takeLatest(types.GET_WAITING_MEMBERS_REQUEST, MembersSaga.getWaitingMembers);
    yield takeLatest(types.GET_CLASSES_FOR_PLANS_REQUEST, MembersSaga.getClassesForPlans);
    yield takeLatest(types.ASSIGN_CLASSES_TO_PLAN_REQUEST, MembersSaga.assignClassesToPlan);
    yield takeLatest(types.RESEND_MEMBER_INVITATION_REQUEST, MembersSaga.resendMemberInvitation);
    yield takeLatest(types.UPDATE_MEMBER_STATUS_REQUEST, MembersSaga.updateMemberStatus);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/MembersSaga.js